import { DateTime } from "luxon";

const adjustTimeForMidnightCross = (
  selectedTime: DateTime,
  selectedDate: DateTime,
  shiftStartTime: DateTime,
  shiftEndTime: DateTime
): DateTime => {
  let adjustedDateTime = selectedDate.set({
    hour: selectedTime.hour,
    minute: selectedTime.minute,
    second: selectedTime.second,
    millisecond: selectedTime.millisecond
  });

  // Note: Only apply midnight crossing logic if this is actually a night shift
  // (i.e., shift end time is on a different day than shift start time)
  const isNightShift = shiftEndTime.day !== shiftStartTime.day;

  if (isNightShift) {
    // Note: If the selected time's hour is less than the start time's hour,
    // it means we've crossed midnight and should add a day
    if (selectedTime.hour < shiftStartTime.hour) {
      adjustedDateTime = adjustedDateTime.plus({ days: 1 });
    }
  }

  return adjustedDateTime;
};

export default adjustTimeForMidnightCross;